import { useEffect } from "react"
import { JSEncrypt } from 'jsencrypt';

export const encryptRSA = (text: string) => {

    const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApVrTMYyl6m1n20QmijT6
PxwsX+52iEjljXo1ui4vjzzcn4mW1DexWZw2Z+4G9QNrVm7jKOZQC5N/kp2PS5hK
vY2YwFcz6x/3igZreWAu1X91qdxSurFMnSbnKnf0zYJnosxDoh+e1XGwLNYGD/eF
i17zhUDFzkVqbkECHqcvCv92DmUcZE0viG7SfOo/mStzin9G4Nhm3IJVMvZ0+Wg0
d7IJ8wixqpgQHxVIr3/Yty1uDk9ePdaZ3bM9e/XKCYOx7D57ewb3JCuH/PtACwmH
AL+PumGnQRsqD0I7v569PRLf/6y1tDssz9vHm09jqRCcxejBUUc1ldCa128YFN2O
fwIDAQAB`

    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);
    return jsEncrypt.encrypt(text); 
}